/**
 * DCL-592: the Plan & usage page. One place that shows a practice what DCL delivers
 * to it and what Premium adds, with one upgrade button. History, the monthly email
 * and the Account Settings badges all link here, tagged with a `src`.
 *
 * Every role sees the same content.
 */
angular.module('admin')
.controller('InsightsController', ['$scope', '$stateParams', '$timeout', '$anchorScroll', 'Logger', 'Subscription', 'SubscriptionHelper', 'UpgradeModal', 'PREMIUM_FEATURES', 'FREE_TRIAL_PERIOD',
    function ($scope, $stateParams, $timeout, $anchorScroll, Logger, Subscription, SubscriptionHelper, UpgradeModal, PREMIUM_FEATURES, FREE_TRIAL_PERIOD) {

        // Features the backend can tell apart as used or not. The rest get no flag:
        // we don't know, so the page doesn't claim anything (DCL-696).
        var TRACKED_FEATURES = ['locations', 'providers', 'cbct', 'branding'];
        var CAPPED_FEATURES = ['locations', 'providers'];

        $scope.loading = true;
        $scope.error = null;
        $scope.insights = null;
        $scope.status = null;
        $scope.statusError = null;
        $scope.features = [];
        $scope.periods = [];
        $scope.section = $stateParams.section || null;
        $scope.trialDays = FREE_TRIAL_PERIOD;

        $scope.isGeneralDentist = function () {
            return !!$scope.insights && $scope.insights.audience === 'general_dentistry';
        };

        $scope.isPremium = function () {
            return !!$scope.status && !!$scope.status.premium_access;
        };

        $scope.planLabel = function () {
            return $scope.status ? SubscriptionHelper.getStatusDescription($scope.status) : '';
        };

        // Same rule as Account Settings: an active complimentary trial can still
        // convert to paid (DCL-508), a paying or Stripe-trialing practice has
        // nothing to buy.
        $scope.showUpgradeButton = function () {
            var status = $scope.status;
            return !!status && (!status.premium_access || !!(status.subscription && status.subscription.complimentary));
        };

        $scope.upgradeButtonText = function () {
            return SubscriptionHelper.getUpgradeButtonText($scope.status);
        };

        $scope.formatPrice = function (cents) {
            return SubscriptionHelper.formatPrice(cents);
        };

        $scope.openUpgradeModal = function () {
            // DCL-645: the page's `src` is the entry point the user came through,
            // which is what DCL-532 attributes the upgrade to.
            UpgradeModal.open({status: $scope.status, source: $stateParams.src || null});
        };

        function buildPeriods(insights) {
            return [
                {key: 'this_month', label: 'This month so far'},
                {key: 'last_month', label: insights.last_month_label},
                {key: 'last_3_months', label: 'Last 3 months'},
                {key: 'last_12_months', label: 'Last 12 months'}
            ].map(function (period) {
                return angular.extend(period, {value: insights.value[period.key]});
            });
        }

        function decorate(feature, insights) {
            var decorated = angular.extend({}, feature);
            if (!$scope.status) { return decorated; }

            if ($scope.isPremium()) {
                if (TRACKED_FEATURES.indexOf(feature.key) !== -1) {
                    decorated.inUse = !!insights.feature_usage[feature.key];
                    decorated.notUsedYet = !decorated.inUse;
                }
            } else if (CAPPED_FEATURES.indexOf(feature.key) !== -1) {
                var limit = insights.plan_limits[feature.key];
                if (limit && !limit.can_add) {
                    decorated.limit = limit;
                }
            }
            return decorated;
        }

        // Runs once both requests have answered. A failed status request still shows
        // the features, without flags or an upgrade button.
        function buildFeatures() {
            var insights = $scope.insights;
            if (!insights) { return; }

            var features = PREMIUM_FEATURES.filter(function (feature) {
                return !(feature.specialistOnly && $scope.isGeneralDentist());
            }).map(function (feature) {
                return decorate(feature, insights);
            });

            // A Premium practice sees what it hasn't tried first (DCL-562).
            $scope.features = features.filter(function (feature) { return feature.notUsedYet; })
                .concat(features.filter(function (feature) { return !feature.notUsedYet; }));

            if ($scope.section) {
                $timeout(function () { $anchorScroll('insights-feature-' + $scope.section); });
            }
        }

        var pending = 2;
        function finished() {
            pending -= 1;
            if (pending === 0) {
                $scope.loading = false;
                buildFeatures();
            }
        }

        Subscription.getInsights({}, function (insights) {
            $scope.insights = insights;
            $scope.periods = buildPeriods(insights);
            finished();
        }, function (error) {
            $scope.error = 'Unable to load your practice summary. Please try again.';
            Logger.log('Error loading insights: ' + JSON.stringify(error));
            finished();
        });

        Subscription.getStatus({}, function (status) {
            $scope.status = status;
            finished();
        }, function (error) {
            $scope.statusError = 'Unable to load your plan.';
            Logger.log('Error loading subscription status: ' + JSON.stringify(error));
            finished();
        });
    }]);
